module.exports = __webpack_public_path__ + "static/img/caigou.fdf6ac1e.png";